<template>
	<div class="main">
		<header class="panel-heading">
			<h3 class="panel-title">設定打掃區域</h3>
		</header>
		<section class="panel panel-default" style="margin-bottom: 0px;">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a id="openSearch" href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">查詢條件</h4>
			</header>
			<div id="searchArea" class="panel-collapse collapse">
				<div class="panel-body">
					<div class="row form-group">
						<div class="col-md-6">
							<label class="col-md-4">房棟</label>
							<div class="col-md-8">
								<select v-model="qryParam.house" @change="changeQryHouse()">
									<option value="">--請選擇--</option>
									<option v-for="(item, key) in houseList" :key="key" :value="item.val" >{{item.val}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-6">
							<label class="col-md-4">樓層</label>
							<div class="col-md-8">
								<select v-model="qryParam.flood" @change="changeQryFlood()">
									<option value="">--請選擇--</option>
									<option v-for="(item, key) in floodList" :key="key" :value="item.val" >{{item.val}}</option>
								</select>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-6">
							<label class="col-md-4">打掃點</label>
							<div class="col-md-8">
								<select v-model="qryParam.cleanLocation">
									<option value="">--請選擇--</option>
									<option v-for="(item, key) in cleanLocationList" :key="key" :value="item.val" >{{item.val}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-6"></div>
					</div>
					<div class="row form-group">
						<div class="col-md-offset-4 col-md-4 ">
							<div class="col-md-offset-4 col-md-4">
								<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<div class="tab-content">
			<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
				<div class="row form-group">
					<div class="col-md-12">
						<table class="table table-no-more table-bordered table-striped mb-none" >
							<thead>
								<tr>
									<th class="text-center" width="5%">學年</th>
									<th class="text-center" width="8%">期別</th>
									<th class="text-center" width="7%">房棟</th>
									<th class="text-center" width="5%">樓層</th>
									<th class="text-center" width="10%">打掃點</th>
									<th class="text-center" width="25%">負責人員</th>
									<th class="text-center" width="30%">設定時間</th>
									<th class="text-center" width="10%">歷史紀錄</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in settingList" :key="index">
									<td data-title="學年" class="text-center">{{item.schoolYear}}</td>
									<td data-title="期別" class="text-center">{{termText[item.term] || item.term}}</td>
									<td data-title="房棟" class="text-center">{{item.house}}</td>
									<td data-title="樓層" class="text-center">{{item.flood}}</td>
									<td data-title="打掃點" class="text-center">{{item.cleanLocation}}</td>
									<td data-title="負責人員" class="text-center">
										<div style="margin-bottom:5px; text-align:left; display:inline-block;">
											<div v-for="(s, k) in (item.selectedStaffList || [])" :key="k">{{ staffLabel(s, item.house) }}</div>
											<div v-if="!(item.selectedStaffList && item.selectedStaffList.length)">--未設定--</div>
										</div>
										<br/>
										<a href="javascript:;" class="btn btn-default" v-if="canEdit" @click="openStaffPopup(item)">選擇人員</a>
									</td>
									<td data-title="設定時間" class="text-center">
										<datepicker name="roomBeginDate" :format="customFormatter" :language="zh" v-model="item.settingBeginDate" :disabled-dates="beginState.disabledDates" :disabled="!canEdit" input-class="form-control" placeholder="開始日期" :style="{width:'46%', display:'inline-block'}" :class="(index > 3? `show-top`:``)"/>
										<span style="width:2%;">~</span>
										<datepicker name="roomEndDate" :format="customFormatter" :disabled-dates="endState.disabledDates" :language="zh" v-model="item.settingEndDate" :disabled="!canEdit" input-class="form-control" placeholder="結束日期" :style="{width:'46%', display:'inline-block'}" :class="index > 3? `show-top`:``"/>
									</td>
									<td data-title="歷史紀錄" class="text-center">
										<a href="javascript:;" class="btn btn-danger" @click="isShowHisPopup = true; hisList=item.hisList">歷史紀錄</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-12">
						<div class="text-center">
							<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
						</div>
					</div>
				</div>
			</div>
		</div>
		<settingCleanStaffHisPopup v-if="isShowHisPopup" :hisList="hisList" />
		<settingCleanStaffSelectPopup v-if="isShowStaffPopup" :stuList="editingItem.stuList" :initStaffList="editingItem.selectedStaffList" />
	</div>
</template>
<script>
import settingCleanStaffHisPopup from './settingCleanStaffHisPopup'
import settingCleanStaffSelectPopup from './settingCleanStaffSelectPopup'
export default {
	components:{
		settingCleanStaffHisPopup,
		settingCleanStaffSelectPopup
	},
	data(){
		return {
			qryParam:{
				house:"",
				flood:"",
				cleanLocation:"",
			},
			houseList:[],
			respFloodList:[],
			settingList:[],
			floodList:[],
			cleanLocationList:[],
			isShowHisPopup:false,
			hisList:[],
			isShowStaffPopup:false,
			editingItem:null,
			page:1,
			totalPage:0,
			canEdit: false,
			termText: {
				"1": "上學期",
				"2": "下學期",
				"W": "寒假",
				"S": "暑假"
			},
			beginState:{
				disabledDates:{
					to: this.nowDate()
				}
			},
			endState:{
				disabledDates:{
					to: this.nowDate()
				}
			},
		};
	},
	created(){
		const now = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
		this.beginState.disabledDates.to = now;
		this.endState.disabledDates.to = now;

		if (this.isAdmin("stay")) {
			this.canEdit = true;
		} else if (this.sessionData.isRoomMage === "Y") {
			this.$axios.post("/api/Environment/cleanSettingStaffIsOpen").then(resp => {
				this.canEdit = (resp.data.status === "success");
			});
		} else {
			this.canEdit = false;
		}
	},
	mounted(){
		this.init();
		this.gridInit();
	},
	updated(){
		if(document.body.clientWidth < 1024){
			let di = document.querySelectorAll(".date-input");
			for(let i=0; i<di.length; i++){
				di[i].style.width = '100%';
			}
			let vdpc = document.querySelectorAll(".vdp-datepicker__calendar");
			for(let i=0; i<vdpc.length; i++){
				vdpc[i].style.width = '180px';
				vdpc[i].style.left="-40px";
			}
		}
	},
	methods:{
		init(){
			const api = "/api/Environment/cleanUpInit";
			this.$axios.post(api).then(resp => {
				this.houseList = resp.data.data.houseList;
				this.respFloodList = resp.data.data.floodList;
			});
		},
		updateGrid(page) {
			this.page = page;
			this.gridInit();
		},
		gridInit(){
			const api = "/api/Environment/cleanUpListByMage";
			this.$axios.post(api, JSON.stringify({
				model:this.qryParam,
				page:this.page,
				pageSize:10
			})).then(resp => {
				let rows = resp.data.data.rows;
				rows.forEach(item => {
					this.$set(item, 'selectedStaffList', item.staffList || []);
				});
				this.settingList = rows;
				this.page = resp.data.data.page;
				this.totalPage = resp.data.data.total;
			});
		},
		changeQryHouse(){
			this.floodList = this.respFloodList.filter(item => {
				return item.key == this.qryParam.house;
			});
		},
		changeQryFlood(){
			if(this.qryParam.house && this.qryParam.flood){
				const api = `/api/Environment/cleanLocationList?house=${this.qryParam.house}&flood=${this.qryParam.flood}`;
				this.$axios.post(api).then(resp =>{
					this.cleanLocationList = resp.data.data;
				});
			}
		},
		staffLabel(s, house){
			let room = s.bedFloorRoom || "";
			if(house && room.indexOf(house) === 0){ room = room.slice(house.length); }
			return room + "-" + (s.bed || "") + " " + (s.account || "") + " " + (s.name || "");
		},
		openStaffPopup(item){
			this.editingItem = item;
			this.isShowStaffPopup = true;
		},
		staffPopupControl(isOpen){
			this.isShowStaffPopup = isOpen;
			if(isOpen == false){
				this.editingItem = null;
			}
		},
		applyStaffSelection(list){
			const item = this.editingItem;
			this.$set(item, 'selectedStaffList', list);
			this.staffPopupControl(false);
			this.clickSettingCleanStaff(item);
		},
		clickSettingCleanStaff(item) {
			let errMsg = [];
			let list = item.selectedStaffList || [];
			if (list.length == 0) errMsg.push("請選擇負責人員");
			if (list.length > 10) errMsg.push("負責人員最多10人");
			if (!item.settingBeginDate) errMsg.push("請選擇有效期間(起)");
			if (!item.settingEndDate) errMsg.push("請選擇有效期間(迄)");
			if (item.settingBeginDate && item.settingEndDate && (item.settingBeginDate > item.settingEndDate)) errMsg.push("有效期間(起)請勿大於(迄)");
			if (errMsg.length) { bootbox.alert(errMsg.join("<br/>")); return; }
			const _this = this;
			this.$axios.post("/api/Environment/settingCleanStaff", JSON.stringify({
				id: item.id,
				staffList: list.map(s => ({ account: s.account, bedFloorRoom: s.bedFloorRoom, bed: s.bed })),
				settingBeginDate: this.customFormatter(item.settingBeginDate),
				settingEndDate: this.customFormatter(item.settingEndDate)
			})).then(resp => {
				bootbox.alert(resp.data.msg, function(){ if (resp.data.status == "success") _this.gridInit(); });
			});
		},
		showHisPopupControl(isOpen){
			if(isOpen == false){
				this.hisList = [];
			}
			this.isShowHisPopup= isOpen;
		}
	}
}
</script>
<style>
.show-top > .vdp-datepicker__calendar{
	bottom: 2.7em;
}
</style>
